<div class="block">
    <span>
        {{message}}
    </span>
</div>